import React, { useEffect, useState } from "react";
import getInvoiceData from "../../functions/invoice/getInvoiceData";
import axios from "axios";
import { notification, Spin } from "antd";
import InvoiceDescription from "../../components/side/invoiceDescription"; // Path to your Lottie JSON file
import Method from "../../components/side/method";
import PaidChecker from "../../functions/invoice/paidChecker";
import SuccessPaidModal from "../../components/modal/successPaid";
import { CreatePosPayment } from "../../functions/pos/CreatePosPayment";
import Loader from "../../components/other/loader";
import { CaretLeftOutlined } from "@ant-design/icons";
import QpayBankList from "../../components/lists/qpayBankList";
import CardPaymentHandler from "../../components/modal/cardPaymentHandler";
import { useUser } from "./context.js/userContext";

const InjectedContext = ({ secureId, defaultMethod }) => {
  const [paymentData, setPaymentData] = useState(null);
  const { paying, setPaying, setReturnUrl, returnUrl, setShowSuccess } =
    useUser();
  const [payMethod, setPayMethod] = useState(defaultMethod);

  useEffect(() => {
    if (secureId) {
      fetchData();
    }
  }, [secureId]);

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        console.log("User returned to tab, checking payment again...");
        await paidChecker();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    setTimeout(() => {
      paidChecker();
    }, 4000);
    setTimeout(() => {
      paidChecker();
    }, 8000);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);
  const paidChecker = async () => {
    const response = await PaidChecker(secureId);
    if (response && response.success) setShowSuccess(true);
  };
  const payQpay = () => {
    if (payMethod !== "QPAY") setPayMethod("QPAY");
  };
  const fetchData = async () => {
    const response = await getInvoiceData(secureId);
    if (!response) {
      return notification.error({ message: "Алдаа гарлаа!" });
    }

    const fullReturnUrl = `${response.returnUrl}${
      response.returnUrl.includes("?") ? "&" : "?"
    }secureId=${secureId}`;

    if (response && response.status === "PAID") {
      setPaying("Захиалга төлөгдсөн байна!");
      setTimeout(() => {
        window.location.href = fullReturnUrl;
      }, 2000);
    }
    setReturnUrl(fullReturnUrl);
    setPaymentData(response);
    setTimeout(() => {
      payQpay();
    }, 200);
    setTimeout(() => {
      window.location.href = fullReturnUrl;
    }, 10 * 60 * 1000);
  };

  if (!paymentData) {
    return <Loader />;
  }
  const back = () => {
    window.location.href = returnUrl;
  };
  const forcePay = async () => {
    try {
      //console.log(paymentData.qpayData.callBackUrl)
      await axios.get(paymentData.qpayData.callBackUrl);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (e) {
      notification.error({ message: "error!" });
    }
  };

  const payCard = () => {
    //return notification.error({ message: 'Tүр засвартаи баина!' })
    setPayMethod("CARD");
  };

  const paySplit = () => {
    notification.error({ message: "Тун удахгүй!" });
    //setPayMethod('SPLIT')
  };

  return (
    <div className="flex flex-col w-[100vw] h-auto bg-gray-400">
      <div className="flex px-3 py-2 rounded-b-xl bg-gray-600 flex-row pt-7 justify-between items-center">
        <button
          onClick={back}
          className="flex  flex-row justify-center items-center gap-[10px] h-[55px] w-[60px] text-center text-[15px] bg-gray-200 rounded-[15px] border-none"
        >
          <CaretLeftOutlined style={{ fontSize: 20, color: "#46CE7C" }} />
        </button>
        {/* <span className="mainColor">SmartPay</span> */}
        {paymentData && String(paymentData.dec).includes("test") && (
          <button onClick={forcePay} className="forcePay">
            PAY!
          </button>
        )}
        <div>
          <img
            src="/smartpay.png"
            alt="logo"
            className="w-[55px] h-[55px] rounded-lg"
          />
        </div>
      </div>
      <div className="flex flex-col p-3">
        <InvoiceDescription data={paymentData} />
        <SuccessPaidModal merchantId={paymentData?.merchantId} />
        <Spin spinning={paying} tip={paying} className="custom-green-spin">
          <div className="flex flex-row gap-3">
            <Method
              onClick={payCard}
              icon={
                <img
                  src="/card.png"
                  alt="cardAdd"
                  className="cardAddIcon"
                  width="40"
                  height="40"
                />
              }
              title={"Картаар төлөх"}
            />

            <Method
              onClick={paySplit}
              disabled={true}
              icon={
                <img
                  src="/split.png"
                  alt="cardAdd"
                  className="cardAddIcon"
                  width="35"
                  height="35"
                />
              }
              title={"Хувааж төлөх"}
              description={"(одоогоор идэвхгүй)"}
            />
            {/* <Method onClick={payPos} loading={loadingPos} icon={<img src="/pos.png" alt="cardAdd" className="cardAddIcon" width="35" height="35" />} title={'Посоор төлөх'} /> */}
          </div>
          <div className="flex flex-col gap-3 mt-3 mb-5 h-[calc(100vh-350px)]">
            {payMethod === "CARD" && (
              <CardPaymentHandler invoice={paymentData} />
            )}
            {payMethod === "SPLIT" && (
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  height: 320,
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              ></div>
            )}
            <QpayBankList invoiceId={paymentData?.id} />
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default InjectedContext;
